import type { NextPage } from 'next'
import Page from 'components/page/authentications/signin'

const Signin: NextPage = () => {
  return <Page />
}

export default Signin
